import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import './i18n';

// Précharger l'image hero critique
const heroImageUrl = 'https://public.readdy.ai/ai/img_res/3e0efdb6388b694ab242e2fd49318a0f.jpg';

const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = heroImageUrl;
preloadLink.fetchPriority = 'high';
document.head.appendChild(preloadLink);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
